import React, {
  FC, useEffect, useState,
} from 'react';
import { v4 as uuid } from 'uuid';
import { RowLeft } from '../Styles';
import { callService } from '../../../../../assets/base64Images/ai/callService';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';
import ReopenButton from '../components/Button/ReopenButton';
import { getCabId32Str, getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import RobotReply from '../components/Reply/RobotReply';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';
import Q7 from '../Q7';
import CheckLoading from '../components/Loading/CheckLoading';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import UserReply from '../components/Reply/UserReply';
import Q15 from '../Q15';
import Q16 from '../Q16';

/**
 * 电话联系客服
 */
const OpenLockFail: FC<Props> = ({
  cabId,
  addElement,
  h5Platform,
  deviceCode,
  qStep,
  openBoxList,
  boxList,
  setTargetPage,
  sessionId,
  enterPhoneNumber,
}) => {
  const openBoxes: { cabId: number; boxNumber: string }[] = [];
  const option = { zhValue: '重新开柜', enValue: 'Reopen' };
  const [saveCallLog] = updateFoodifoxData('/foxH5RentLog/saveCallServiceLog');
  // 开锁
  const [openLock] = getFoodifoxDataLazy<boolean>('/fox3PDAi/boxOpenLock');
  // 请求次数
  const [requestCount, setRequestCount] = useState<number>(1);

  /**
   * 尝试次数增加时，自动追加节点
   */
  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ alignItems: 'center' }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.55, getWindowWidth() * 0.58) }}
            langZh={
              requestCount > 1 ?
                <>
                  由于网络问题，柜门开启失败。您可以在5分钟内尝试重新开柜。如果需要帮助，请拨打我们的人工服务热线 <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> (<span style={{ fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600 }}>工作日 早上 9:00 至下午 5:00</span>)
                </> :
                <>
                  {
                    // 柜门数量和打开的数量不相等，说明有个别柜门开启失败
                    boxList.length !== openBoxList.length ?
                      <>
                        请从打开的柜门里取走您的食物并关上柜门。
                        <br />
                        您仍然有别的食物在智能柜里，但是由于网络原因，另一个柜门开启失败。您可以在5分钟内尝试重新开柜。如果需要帮助，请拨打我们的人工服务热线 <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> (<span style={{ fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600 }}>工作日 早上 9:00 至下午 5:00</span>)
                      </> :
                      <>
                        由于网络问题，柜门开启失败。请检查网络后重试打开柜门。如果需要帮助，请拨打我们的人工服务热线 <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> (<span style={{ fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600 }}>工作日 早上 9:00 至下午 5:00</span>)
                      </>
                  }
                </>
            }
            langEn={
              requestCount > 1 ?
                <>
                  We have verified your order, but the locker isn’t responding. You can try again in 5min, or call us on <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> for human support on <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>Weekdays 9:00am - 5:00pm</span>.
                </> :
                <>
                  {
                    // 柜门数量和打开的数量不相等，说明有个别柜门开启失败
                    boxList.length !== openBoxList.length ?
                      <>
                        Please take your food from the open cubicle and close the door. Whoops, it looks like you have more food but there was an error opening one of the cubicles. You can try again in 5min, or call us on <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> for human support on <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>Weekdays 9:00am - 5:00pm</span>.
                      </> :
                      <>
                        We have verified your order, but the locker isn’t responding. You can try again in 5min, or call us on <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> for human support on <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>Weekdays 9:00am - 5:00pm</span>.
                      </>
                  }
                </>
            }
          />
          <img
            src={callService}
            style={{ width: 41, height: 41, marginLeft: 20 }}
            onClick={() => {
              addSystemLog(cabId, deviceCode, h5Platform + '', 'Q18 - user: call service', sessionId);
              location.href = 'tel:1300359889';
              saveCallLog({
                param: {
                  cabId: getCabId32Str(cabId),
                  telNumber: '1300359889',
                },
              });
            }}
          />
        </RowLeft>
      </LeftToRight>
    );

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <ReopenButton
              flowId={flowId}
              langZh={option.zhValue}
              langEn={option.enValue}
              callback={() => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q' + qStep + '开门失败，重新开门 - ' + lang(option.enValue, option.zhValue), sessionId);

                addElement(
                  <UserReply
                    langZh={option.zhValue}
                    langEn={option.enValue}
                  />
                );
                setTimeout(() => {
                  const loadingFlowId = uuid();
                  addElement(
                    <CheckLoading
                      flowId={loadingFlowId}
                      zhText={'请稍等…正在连接至智能柜…'}
                      enText={'Please wait...We are connecting with your locker.'}
                      style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.55, getWindowWidth() * 0.58) }}
                    />
                  );
                  openBox(0, loadingFlowId);
                }, 400);
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 400);
  }, [requestCount]);

  /**
   * 开门
   * @param index 柜门下标，从0开始
   * @param loadingFlowId 加载动画的flowId
   */
  const openBox = (index: number, loadingFlowId: string) => {
    // 过滤出没有开的门
    const box = openBoxList.filter((item) => !openBoxes.find(({ cabId, boxNumber }) => item.cabId === cabId && boxNumber === item.boxNumber))[index];
    if (!box) {
      if (openBoxes.length === openBoxList.length) {
        if (qStep === 7) {
          addElement(
            <Q7
              boxList={boxList}
              addElement={addElement}
              setTargetPage={setTargetPage}
              cabId={cabId}
              h5Platform={h5Platform}
              deviceCode={deviceCode}
              loadingFlowId={loadingFlowId}
              needOpenLock={false}
              sessionId={sessionId}
              enterPhoneNumber={enterPhoneNumber}
            />
          );
        }
        if (qStep === 15) {
          addElement(
            <Q15
              cabId={cabId}
              boxList={boxList}
              addElement={addElement}
              setTargetPage={setTargetPage}
              h5Platform={h5Platform}
              deviceCode={deviceCode}
              loadingFlowId={loadingFlowId}
              needOpenLock={false}
              sessionId={sessionId}
              enterPhoneNumber={enterPhoneNumber}
            />
          );
        }
        if (qStep === 16) {
          addElement(
            <Q16
              cabId={cabId}
              boxList={boxList}
              addElement={addElement}
              setTargetPage={setTargetPage}
              h5Platform={h5Platform}
              deviceCode={deviceCode}
              loadingFlowId={loadingFlowId}
              needOpenLock={false}
              sessionId={sessionId}
              enterPhoneNumber={enterPhoneNumber}
            />
          );
        }
      }
      else {
        // 隐藏loading
        TempFieldUtils.aiFlowIds.push(loadingFlowId);
        setRequestCount(requestCount + 1);
      }
      return;
    }

    openLock({
      param: {
        ...box,
      },
      onCompleted(status) {
        if (status) {
          openBoxes.push(box);
        }
        openBox(index += 1, loadingFlowId);
      },
    });
  };

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  addElement: (elements: any) => void;
  deviceCode: string;
  h5Platform: number;
  qStep: number;
  openBoxList: { cabId: number; boxNumber: string }[]; // 需要开门柜门列表
  boxList: { cabId: number; boxNumber: string; boxId: number }[];  // 柜门列表，重新开门后有些步骤需要传递原来的柜门列表，这个参数就是做这个用的
  setTargetPage: (targetPage: string) => void;
  sessionId: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default OpenLockFail;
